import { createFileRoute, redirect } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { Languages } from "lucide-react";
import { PlaceholderPage } from "@/components/vroom/placeholder-page";
import type { RoleKind } from "@/components/vroom/role-pill";

interface SessionUser {
  name: string;
  email: string;
  role?: RoleKind;
}

export const Route = createFileRoute("/_authed/admin/translations")({
  beforeLoad: ({ context }) => {
    const user = (context as { user?: { role?: string } }).user;
    if (user?.role !== "super_admin") throw redirect({ to: "/dashboard" });
  },
  component: TranslationsAdmin,
});

function TranslationsAdmin() {
  const { t } = useTranslation();
  const { user } = Route.useRouteContext() as { user: SessionUser };
  return (
    <PlaceholderPage
      user={{ name: user.name, role: "super_admin" }}
      section="admin"
      activeKey="translations"
      breadcrumb={<>{t("admin.translations.breadcrumb")}</>}
      title={t("admin.translations.title")}
      icon={<Languages size={48} />}
    />
  );
}
